import React from 'react'
import { TableRowField } from '../../../../components'
import { formatHelper } from '../../../../common/helpers'

export const averageTicketXS = [
    {
        dataField: 'xs',
        text: 'Venta',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Nombre:' value={row.name} />
                    <TableRowField label='Cantidad de Ventas:' value={row.quantity} />
                    <TableRowField label='Venta Promedio (S/):' value={formatHelper.toMoney(row.average_ticket)} />
                </div>
            )
        }
    }
]

export const averageTicketSM = [
    {
        dataField: 'sm',
        text: 'Venta',
        formatter: (cell, row) => {
            return (
                <div>
                    <TableRowField label='Nombre:' value={row.name} />
                </div>
            )
        }
    },
    {
        dataField: 'quantity',
        text: 'Cantidad de Ventas'
    },
    {
        dataField: 'average_ticket',
        text: 'Venta Promedio (S/)',
        formatter: (cell) => {
            return <span>{formatHelper.toMoney(cell)}</span>
        }
    }
]

export const averageTicket = [
    {
        dataField: 'name',
        text: 'Nombre'
    },
    {
        dataField: 'quantity',
        text: 'Cantidad de Ventas'
    },
    {
        dataField: 'average_ticket',
        text: 'Venta Promedio (S/)',
        formatter: (cell) => {
            return <span>{formatHelper.toMoney(cell)}</span>
        }
    }
]


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardAverageTicket/_columns.js